export default __webpack_public_path__ + "static/media/emoji-flag-en.4ec89932.png";